<template>
    <div
        :class="[
            type === 'error' ? 'border-r-red text-r-red' : '',
            type === 'info-green'
                ? 'border-r-green text-r-black bg-r-green-5'
                : '',
            type === 'success'
                ? 'border-r-green bg-r-green-5 text-r-green'
                : '',
            padding,
        ]"
        class="flex flex-row items-center space-x-4 border-2 rounded-lg"
    >
        <div :class="iconClass" v-if="icon && hasIcon">
            <font-awesome-icon
                v-if="icon !== null"
                :icon="icon"
                :class="[type === 'info-green' ? 'text-r-green' : '']"
            ></font-awesome-icon>
        </div>
        <div class="text-base">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        icon() {
            if (this.type === "error") {
                return "triangle-exclamation";
            }
            if (this.type === "info-green") {
                return "circle-info";
            }
            return null;
        },
    },
    props: {
        type: {
            required: false,
            default: "error",
            type: String,
        },
        hasIcon: {
            required: false,
            default: true,
            type: Boolean,
        },
        padding: {
            required: false,
            default: "md:p-6 p-4",
        },
        iconClass: {
            required: false,
            default: "text-xl",
        },
    },
};
</script>

<style></style>
